// Module
var code = "<template click.trigger=\"onClick()\"> <require from=\"./modal-backdrop.scss\"></require> </template> ";
// Exports
module.exports = code;